import * as angular from 'angular';
import * as moment from 'moment';

angular
  .module('screeningcanvas')
  .filter('formatTime', function () {
    return function (input) {
      if (!!input) {
        return moment(input).format('HH:mm');
      } else {
        return null;
      }
    };
  });
